import React from 'react';
import PropTypes from 'prop-types';
import TableHeader from '../table-header/TableHeader';
import { localize } from '../../../common/localization';
import IdelLink from './IdelLink';
import { COLUMNS_NAMES, SECTION_NAMES } from '../../../common/utils/studentsSortingHelpers';
import { IDEL } from '../../../constants/applications';
import { SUPPORTED_GRADES_BY_APP } from '../../../constants/assessments';
import { usePopupContext } from '../../../common/contexts/PopupContext';

const IdelSummary = ({ studentGrade }) => {
    const {
        actions: { showNoIDELSupportPopup },
    } = usePopupContext();

    return (
        SUPPORTED_GRADES_BY_APP[IDEL].includes(studentGrade) && (
            <>
                <TableHeader columns={[localize(COLUMNS_NAMES.IDEL)]} />
                <IdelLink
                    label={SECTION_NAMES.IDEL_SCREENER}
                    onClickHandle={showNoIDELSupportPopup}
                />
            </>
        )
    );
};

IdelSummary.propTypes = {
    studentGrade: PropTypes.string.isRequired,
};

export default IdelSummary;
